import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@mantine/core';
import { Link } from 'react-router-dom';
import { IconExternalLink } from '@tabler/icons-react';
import React from 'react';


type Props = {
    children: React.ReactNode,
    link?: string,
    title?: React.ReactNode,
    onClose?: () => void,
    opened?: boolean
    size?: string
    position?: 'left' | 'right' | 'top' | 'bottom'
}

export default function DrawerPage({
    children,
    link,
    title,
    onClose,
    opened,
    size,
    position
}: Props) {
    const { t } = useTranslation();

    return (
        <Drawer
            overlayProps={{ backgroundOpacity: 0, blur: 0 }}
            position={position || 'right'}
            size={size || '60%'}
            opened={opened}
            onClose={onClose}
            styles={{
                content: {
                    paddingBottom: "200px",
                    boxShadow: '-8px 0 24px rgba(0, 0, 0, 0.15), -4px 0 8px rgba(0, 0, 0, 0.1)',
                    backgroundColor: '#fcfbfa',
                },
                header: {
                    borderBottom: '1px solid #dee2e6',
                    marginBottom: '10px',
                    minWidth: 'max-content',
                }
            }}
            title={
                <div>
                    {
                        link &&
                        <Link
                            tabIndex={-1}
                            to={link}
                            target='_blank'>
                            <Button
                                size='xs'
                                radius='lg'
                                variant='outline'
                                color="gray"
                                tabIndex={-1}
                                rightSection={<IconExternalLink size={16} stroke={1} />}
                            >
                                {t('open')}
                            </Button>
                        </Link>
                    }
                    {title ? title : null}
                </div>
            }
        >
            {children}
        </Drawer>
    );
}